import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  useMediaQuery,
  makeStyles,
} from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { Button, H1 } from 'components/Ui';
import arrow from 'images/arrow-button.svg';
import commonStyles from './styles.scss';

const useStyles = makeStyles((theme) => ({
  panel: {
    backgroundColor: theme.colors.whiteGrey,
    boxShadow: 'none',
    position: 'inherit',
    '&$expanded': {
      margin: 0,
    },
  },
  expanded: {},
  summary: {
    padding: '35px 0',
    width: '90%',
    margin: 'auto',
    borderTop: theme.borders.greyBorder(false),
    '&$expanded': {
      minHeight: '48px',
    },
  },
  summaryContent: {
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '20px 0',
    '&$expanded': {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  summaryButtonWrapper: {
    position: 'absolute',
    bottom: '35px',
  },
  panelDetails: {
    padding: 0,
    width: '90%',
    margin: 'auto',
  },
}));

const Block = ({ children, title, buttonText, onClick }) => {
  const [expanded, setExpanded] = useState(false);
  const theme = useTheme();
  const classes = useStyles();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleChange = (event, isExpanded) => {
    setExpanded(isExpanded);
  };

  const handleClick = (event) => {
    event.stopPropagation();
    onClick();
  };

  if (isMobile) {
    return (
      <ExpansionPanel
        classes={{
          root: classes.panel,
          expanded: classes.expanded,
        }}
        onChange={handleChange}
      >
        <ExpansionPanelSummary
          classes={{
            root: classes.summary,
            content: classes.summaryContent,
            expanded: classes.expanded,
          }}
          expandIcon={<img src={arrow} alt="expand" />}
        >
          <H1 className={commonStyles.blockHeaderText}>{title}</H1>
          {expanded && (
            <Button
              link
              text={buttonText}
              onClick={handleClick}
              className={classes.summaryButtonWrapper}
            />
          )}
        </ExpansionPanelSummary>
        <ExpansionPanelDetails classes={{ root: classes.panelDetails }}>
          <div className={commonStyles.blockContent}>{children}</div>
        </ExpansionPanelDetails>
      </ExpansionPanel>
    );
  }

  return (
    <div className={commonStyles.container}>
      <div className={commonStyles.blockContainer}>
        <div className={commonStyles.blockHeaderContainer}>
          <H1 className={commonStyles.blockHeaderText}>{title}</H1>
          {buttonText && onClick && (
            <Button
              className={commonStyles.openButton}
              text={buttonText}
              onClick={onClick}
            />
          )}
        </div>
        <div className={commonStyles.blockContent}>{children}</div>
      </div>
    </div>
  );
};

Block.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  buttonText: PropTypes.string,
  onClick: PropTypes.func,
};

export default Block;
